/**
 * 通用格式化工具（纯函数，无 React 依赖）。
 *
 * 计时器口径：内部状态一律使用毫秒；显示沿用棋钟惯例向上取整，
 * 保证「还剩 0.4 秒」显示 00:01 而不是 00:00。
 */

/** 毫秒 → mm:ss（负数归零；分钟位可超过两位） */
export function formatClock(ms: number): string {
  const safe = Number.isFinite(ms) ? ms : 0;
  const totalSeconds = Math.max(0, Math.ceil(safe / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

/** 毫秒 → 中文可读时长，如「2 分 05 秒」 */
export function formatDuration(ms: number): string {
  const totalSeconds = Math.max(0, Math.round((Number.isFinite(ms) ? ms : 0) / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return minutes > 0 ? `${minutes} 分 ${String(seconds).padStart(2, '0')} 秒` : `${seconds} 秒`;
}

/** 秒 → mm:ss（赛程预算等秒级数据） */
export function formatSeconds(seconds: number): string {
  return formatClock(seconds * 1000);
}

/** 安全地计算百分比（0~100 的整数），分母为 0 时返回 0 */
export function percent(part: number, total: number): number {
  if (!Number.isFinite(part) || !Number.isFinite(total) || total <= 0) return 0;
  return Math.max(0, Math.min(100, Math.round((part / total) * 100)));
}

/** 剩余毫秒是否进入终极预警区间（≤15 秒，SPEC §5.2 clock-warning） */
export const CLOCK_WARNING_MS = 15_000;

export function isClockWarning(remainingMs: number): boolean {
  return remainingMs > 0 && remainingMs <= CLOCK_WARNING_MS;
}

export function clampText(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return `${text.slice(0, Math.max(0, maxLength - 1))}…`;
}
